import { makeStyles, tokens } from '@fluentui/react-components';

export const useMoveLineStyles = makeStyles({
    root: {},
    menuButton: {
        marginLeft: tokens.spacingHorizontalS,
        cursor: 'pointer',
        fontSize: tokens.fontSizeBase500
    }
});
